<template>
  <div>
    <NuxtPage />
  </div>
</template>
<script lang="ts"></script>
